import React from 'react';

import SvgIcon from './svg-icon';

export function OldCoupleAlt(props) {
    return (
        <SvgIcon svg="old-couple-1" {...props} />
    );
}
